<template>
  <v-navigation-drawer hide-overlay floating v-model="data.plotItemViewActive" class="offset-drawer">
    <v-card class="d-flex flex-column ma-0 pa-0" flat v-if="plotItem">
      <div class="d-flex flex-row justify-content-between mt-3 mx-2 align-center">
        <div class="d-flex flex-column">
          <h4 class="pa-0 d-flex align-center text-uppercase"><img height="16" class="mr-1" :src="'/static/kantons/' + String(plotItem.CANTON).toLowerCase() + '.png'" /> {{ plotPrefix }}-{{ plotItem.STATE?.substr(0, 2) }}-{{ plotItem.LOCNAME }}-{{ plotItem.PRC_NO }}</h4>
          <small>{{ plotItem.PRC_COU }}, {{ plotItem.STREET_ADDRESS ? plotItem.STREET_ADDRESS.trim() : $t("no-address") }}, {{ plotItem.PRC_ZIP }}</small>
        </div>
        <v-spacer></v-spacer>
        <v-btn fab elevation="0" class="red--text align-self-start" x-small @click="clearClickView"><v-icon>mdi-close</v-icon></v-btn>
      </div>

      <v-row dense>
        <v-col cols="12">
          <div class="d-flex justify-content-between" style="height: 240px; width: 100%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; margin: 0px; padding: 2px 4px">
            <canvas class="ma-2 d-block" style="box-shadow: 0 0 10px -5px black; border-radius: 8px" id="canvas" width="240" height="240"></canvas>
            <div style="background-color: #fff; width: 100%; flex: 1; height: 100%; padding: 5px 10px" class="ml-2">
              <ul style="list-style-type: none; padding: 0; font-size: 11px; line-height: 1">
                <li>
                  <b>{{ $t("building-type") }}</b>
                </li>
                <li style="padding-bottom: 5px !important">
                  <hr />
                </li>
                <li style="margin-bottom: 4px" v-for="(value, objectType) of objectColors" :key="objectType">
                  <div style="height: 12px; width: 12px; display: inline-block; margin-right: 3px" :style="'background-color:' + value">&nbsp;</div>
                  {{ $t(objectType) }}
                </li>
                <li>
                  <hr />
                </li>
                <li><span style="color: orange; font-size: 16px">&#9679;</span> {{ $t("protected-object") }}</li>
              </ul>
            </div>
          </div>
          <div class="d-flex my-2">
            <v-btn class="primary darken-1 ml-3" dark small @click="onOptionButton('reports')">{{ $t("reports") }}</v-btn>
            <v-btn class="primary darken-1 ml-3" dark small @click="onOptionButton('downloads')">{{ $t("downloads") }}</v-btn>
            <v-btn v-if="profile" class="primary darken-1 ml-3" dark small @click="onOptionButton('aimode')">{{ $t("ai-mode") }}</v-btn>
          </div>
          <!-- <div class="grey lighten-2 py-2 d-none">
            <div class="mx-auto text-center d-flex flex-row justify-space-around flex-wrap">
              <v-btn class="grey darken-1 mx-auto d-block pa-0 px-1 ma-0" dark x-small @click="fullReportPDF(plotItem)">{{ $t("full-report") }}</v-btn>
              <v-btn @click="openOREB" class="grey darken-1 mx-auto d-block pa-0 px-1 ma-0" dark x-small>{{ $t("oreb") }}</v-btn>

              <v-btn @click="openDFX" class="grey darken-1 mx-auto d-block pa-0 px-1 ma-0" dark x-small>{{ $t("dxf") }}</v-btn>
              <v-btn @click="openDWG" class="grey darken-1 mx-auto d-block pa-0 px-1 ma-0" dark x-small>{{ $t("dwg") }}</v-btn>
              <v-btn @click="openIFC" class="grey darken-1 mx-auto d-block pa-0 px-1 ma-0" dark x-small>{{ $t("ifc") }}</v-btn>
              <v-btn @click="openBaureglement" class="grey darken-1 mx-auto d-block pa-0 px-1 ma-0" dark x-small>{{ $t("baureglement") }}</v-btn>
              <v-btn @click="openSolarPotential" class="grey darken-1 mx-auto d-block pa-0 px-1 ma-0" dark x-small>{{ $t("solar-potential") }}</v-btn>
              <v-btn @click="open3dElevation" class="grey darken-1 mx-auto d-block pa-0 px-1 mt-1 ma-0" dark x-small>{{ $t("ed-elevation") }}</v-btn>
              <v-btn @click="aiReportForPlot" class="grey darken-1 mx-auto d-block pa-0 px-1 mt-1 ma-0" dark x-small>{{ $t("plot-ai-report") }}</v-btn>
            </div>
          </div> -->
        </v-col>
        <v-col cols="12" class="plot-full-details" style="overflow-y: auto; max-height: calc(100vh - 420px)">
          <ViewPlotDetails100 :plotItem="plotItem" />
          <v-expansion-panels flat class="flat-expanssion-panel" eager>
            <v-expansion-panel>
              <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text d-flex align-center justify-content-between">
                <v-tooltip color="white" v-if="contentJson?.lang?.[lang]?.text || contentJson?.text" right content-class="tooltip-box-content" max-width="360" :open-delay="300" :close-delay="200" transition="slide-x-transition">
                  <template v-slot:activator="{on, attrs}">
                    <div v-bind="attrs" v-on="on" style="margin-right: -40px">{{ $t("basic-data-building") }} ({{ objectItems?.length }})</div>
                  </template>
                  <div v-html="contentJson?.lang?.[lang]?.text || contentJson?.text"></div>
                </v-tooltip>
                <div v-else style="margin-right: 26px">{{ $t("basic-data-building") }} ({{ objectItems?.length }})</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div id="objects-zone">
                  <v-tabs dense align-with-title next-icon="mdi-arrow-right-bold-box-outline" prev-icon="mdi-arrow-left-bold-box-outline" show-arrows center-active v-model="tabViewObject">
                    <v-tabs-slider color="blue"></v-tabs-slider>
                    <v-tab v-for="(objectItem, index) of objectItems" :key="index">
                      {{ objectItem.OBJ_ID }}
                    </v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tabViewObject" v-if="objectItems && objectItems.length > 0">
                    <v-tab-item eager v-for="(objectItem, index) of objectItems" :key="index + '-det'">
                      <div class="d-flex justify-content-between ml-3 my-3" style="height: 120px; width: 100%">
                        <canvas :id="'canvas_obj_' + objectItem.OBJ_ID" class="mr-2 d-block" style="box-shadow: 0 0 10px -5px black; border-radius: 8px" width="120" height="120"></canvas>
                        <div style="width: 100%; flex: 1; height: 100%; padding: 5px 10px">
                          <v-simple-table dense>
                            <template v-slot:default>
                              <tbody>
                                <tr>
                                  <td>{{ $t("object-id") }}</td>
                                  <td>{{ objectItem.OBJ_ID }}</td>
                                </tr>
                                <tr>
                                  <td>{{ $t("number") }}</td>
                                  <td>{{ objectItem.OBJ_STN }}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <b>{{ $t("footprint-area") }}</b>
                                  </td>
                                  <td>
                                    <b>{{ objectItem.OBJ_SUR }}</b> m²
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b>{{ $t("building-volume") }}</b>
                                  </td>
                                  <td>
                                    <b>{{ objectItem.OBJ_VOL }}</b> m³
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                      </div>
                      <ViewPlotDetails200 :plotItem="plotItem" :objectItem="objectItem" />
                    </v-tab-item>
                  </v-tabs-items>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <ViewPlotDetails300 :plotItem="plotItem" />
          <ViewPlotDetails400 :plotItem="plotItem" />
          <ViewPlotDetails500 :plotItem="plotItem" />
          <ViewPlotDetails600 :plotItem="plotItem" />
          <ViewPlotDetails700 :plotItem="plotItem" />
          <ViewPlotDetails800 :plotItem="plotItem" />
          <ViewPlotDetails900 :plotItem="plotItem" />
          <ViewPlotDetails1001 :plotItem="plotItem" />
          <ViewPlotDetails1002 :plotItem="plotItem" class="mb-5" @drawFixPoint="onDrawFixPoint" />
        </v-col>
      </v-row>
    </v-card>
  </v-navigation-drawer>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from "vue-property-decorator"
import ViewPlotDetails100 from "./ViewPlotDetails100.vue"
import ViewPlotDetails200 from "./ViewPlotDetails200.vue"
import ViewPlotDetails300 from "./ViewPlotDetails300.vue"
import ViewPlotDetails400 from "./ViewPlotDetails400.vue"
import ViewPlotDetails500 from "./ViewPlotDetails500.vue"
import ViewPlotDetails600 from "./ViewPlotDetails600.vue"
import ViewPlotDetails700 from "./ViewPlotDetails700.vue"
import ViewPlotDetails800 from "./ViewPlotDetails800.vue"
import ViewPlotDetails900 from "./ViewPlotDetails900.vue"
import ViewPlotDetails1001 from "./ViewPlotDetails1001.vue"
import ViewPlotDetails1002 from "./ViewPlotDetails1002.vue"
import {searchService} from "./service"
import {config, utils} from "@/libs/utils"

@Component({
  components: {ViewPlotDetails100, ViewPlotDetails200, ViewPlotDetails300, ViewPlotDetails400, ViewPlotDetails500, ViewPlotDetails600, ViewPlotDetails700, ViewPlotDetails800, ViewPlotDetails900, ViewPlotDetails1001, ViewPlotDetails1002},
})
export default class ViewPlotDetails extends Vue {
  plotPrefix = config.VUE_APP_PLOT_NUMBER_PREFIX

  @Prop()
  plotItem

  @Prop()
  objectItems

  @Prop()
  canton

  tabViewObject = -1
  tabViewDetails = 0
  objectSelected = null

  lang

  data: any = {
    items: [],
    plotItemViewActive: false,
  }

  contentJson: any = {}

  profile

  constructor() {
    super()
    this.profile = this.$store.getters.profile
    this.lang = this.$i18n.locale || localStorage.getItem("user-language")
  }

  created() {
    this.loadTooltip()
  }

  onDrawFixPoint(val) {
    this.$emit("drawFixPoint", val)
  }

  onOptionButton(btn) {
    console.log("onOptionButton data plot view", btn)
    this.$emit("onOptionButton", btn)
  }

  async loadTooltip() {
    this.contentJson = (await this.$store.dispatch("tooltip/getTooltipContent", "section200")) || {}
  }

  // openOREB() {
  //   if (this.canton?.urlOREB) {
  //     window.open(this.canton.urlOREB + this.plotItem.PRC_ID, "_blank")
  //   }
  // }

  // openDFX() {
  //   window.open("https://dxf.terrara.ch/dxf/dxf.php?id=" + this.plotItem.PRC_ID + "&lang=" + this.lang + "&canton=" + this.plotItem.CANTON, "_blank")
  // }
  // openDWG() {
  //   window.open("https://dwg.terrara.ch/dwg/dwg.php?id=" + this.plotItem.PRC_ID + "&lang=" + this.lang + "&canton=" + this.plotItem.CANTON, "_blank")
  // }
  // openIFC() {
  //   window.open("https://ifc.terrara.ch/ifc/ifc.php?id=" + this.plotItem.PRC_ID + "&lang=" + this.lang + "&canton=" + this.plotItem.CANTON, "_blank")
  // }
  // openBaureglement() {
  //   window.open("https://baureglement.terrara.ch/baureglement/baureglement.php?gemainde=" + this.plotItem.PRC_MUN + "&lang=" + this.lang + "&canton=" + this.plotItem.CANTON, "_blank")
  // }

  // open3dElevation() {
  //   if (this.plotItem && this.plotItem.PRC_ID) {
  //     window.open(`https://elevation.terrara.ch/elevation-3d-db2.php?prcid=${this.plotItem.PRC_ID}`, "_blank")
  //   }
  // }

  async aiReport() {
    if (this.plotItem && this.plotItem.PRC_ID) {
      let oneTimeToken = await searchService.getAIReportOneTimeToken(this.plotItem.PRC_ID)
      console.log("oneTimeToken", oneTimeToken)
      if (oneTimeToken && oneTimeToken.token) {
        let url = searchService.getUrl() + "/v1/secure/user/ai-reports/generate-ai-report?prcid=" + this.plotItem.PRC_ID + "&lang=" + this.lang + "&ott_token=" + oneTimeToken.token
        console.log("url", url)
        window.open(url, "_blank")
      } else {
        const msg = this.$t("no-ai-report-available") as string
        utils.showSnackbarError(msg)
      }
    } else {
      const msg = this.$t("no-plot-item-selected") as string
      utils.showSnackbarError(msg)
    }
  }
  // async aiReportForPlot() {
  //   if (this.plotItem && this.plotItem.PRC_ID) {
  //     let oneTimeToken = await searchService.getAIReportOneTimeToken(this.plotItem.PRC_ID)
  //     console.log("oneTimeToken", oneTimeToken)
  //     if (oneTimeToken && oneTimeToken.token) {
  //       let url = searchService.getUrl() + "/v1/secure/user/ai-reports/generate-ai-report-for-plot?prcid=" + this.plotItem.PRC_ID + "&lang=" + this.lang + "&ott_token=" + oneTimeToken.token
  //       console.log("url", url)
  //       window.open(url, "_blank")
  //     } else {
  //       const msg = this.$t("no-ai-report-available") as string
  //       utils.showSnackbarError(msg)
  //     }
  //   } else {
  //     const msg = this.$t("no-plot-item-selected") as string
  //     utils.showSnackbarError(msg)
  //   }
  // }

  // openSolarPotential() {
  //   let urlSolarPotential = ""
  //   //https://pdf.terrara.ch/solarcomposer/solar-potential-php-script.php?
  //   //append these lv95[]=2723863,1210819,5436543&lv95[]=2723884,1210811,5436543 to url based on all OBJ-COO-X and OBJ-COO-Y  values from objectItems
  //   let lv95: any = []
  //   this.objectItems.forEach((item) => {
  //     if (item.OBJ_COO_X && item.OBJ_COO_Y) {
  //       lv95.push(item.OBJ_COO_X + "," + item.OBJ_COO_Y + "," + item.OBJ_ID)
  //     }
  //   })
  //   if (lv95.length > 0) {
  //     urlSolarPotential += "?lv95[]=" + lv95.join("&lv95[]=")
  //   }
  //   console.log("urlSolarPotential", urlSolarPotential)
  //   window.open("https://pdf.terrara.ch/solarcomposer/solar-potential-php-script.php" + urlSolarPotential + "&lang=" + this.lang + "", "_blank")
  // }

  objectColors: {string: string} = config.VUE_APP_PLOT_OBJECT_COLORS

  @Watch("tabViewObject")
  async onTabViewObjectChange(val) {
    if (val >= 0) {
      let obj = this.objectItems[val]
      this.$emit("onObjectItemClicked", obj)
      this.objectSelected = obj
    }
  }

  @Watch("plotItem")
  async onPlotItemChange(val) {
    this.tabViewObject = -1
    if (val) {
      this.data.plotItemViewActive = true
    } else {
      this.data.plotItemViewActive = false
    }
  }

  // async fullReportPDF(plotItem) {
  //   console.log("fullReportPDF", plotItem)
  //   // this.$emit("onFullReport", plotItem)
  //   window.open("https://full.terrara.ch/fullreport/full.php?id=" + this.plotItem.PRC_ID + "&lang=" + this.lang)
  // }

  async clearClickView() {
    this.$emit("onClearClickView")
  }
}
</script>
<style>
.offset-drawer {
  left: 258px !important;
  min-width: 480px;
  position: absolute;
  max-width: 100%;
  margin-top: 0px;
  border-radius: 0px;
  height: calc(100vh - 64px) !important;
  z-index: 1 !important;
  box-shadow: rgba(1, 1, 1, 0.5) 1px 0px 20px -8px;
}

.table-small{
  width: 100%;
  border-collapse: collapse;
  margin: 2px 10px 2px 26px;
  
  td, th {
    font-size:12px !important;
    border-bottom: 1px solid #ddd !important;
    padding: 2px !important;
  }
  
}
.plot-full-details {
  padding: 0px !important;
}

.plot-full-details > table {
  width: 100%;
  margin-top: 5px;
}

.plot-full-details > table td:first-child {
  width: 55%;
}

.plot-full-details > table thead th {
  background-color: #fafafa;
  font-size: 15px !important;
  color: #000;
  height: 40px;
}

.v-expansion-panel-header {
  padding: 10px 16px !important;
  min-height: 32px !important;
  font-weight: 500 !important;
}
</style>
